import { Form, Input, InputNumber } from "antd";
import { Rule } from "antd/es/form";
import { FormInstance } from "antd/lib/form";
import { NumericInput } from "components/inputs/NumericInput";
import { read } from "fs";
import { t } from "i18next";

export const Bills = ({
  name,
  required = false,
  disabled = false,
  rules,
  readOnly = false,
  form,
}: {
  name?: string;
  required?: boolean;
  disabled?: boolean;
  rules: Rule[];
  readOnly?: boolean;
  form: FormInstance;
}) => {
  return (
    <Form.Item
      label={<>{t("work_cost")}</>}
      name={name}
      rules={rules}
      required={required}
    >
      <NumericInput
        readOnly={readOnly}
        disabled={disabled}
        dir="auto"
        autoComplete="off"
        type="text"
      />
    </Form.Item>
  );
};
